import type { StaticImageData } from 'next/image'
import type { ComponentType } from 'react'
import platformImgOne from '../../../assets/platform-1.png'
import platformImgTwo from '../../../assets/platform-2.png'
import platformImgThree from '../../../assets/platform-3.png'
import {
  ClientsStatCard,
  ComplianceStatCard,
  PricingStatCard,
  RequestsStatCard,
} from '../../stat-cards'

/** A text-and-artwork slide (heading → image → description). */
export interface MediaSlide {
  kind: 'media'
  id: string
  heading: string
  description: string
  /**
   * Slide artwork. `null` renders no media — swap in a real platform screenshot
   * when one is available.
   */
  image: StaticImageData | null
}

/** A slide whose body is a self-contained stat card. */
export interface CardSlide {
  kind: 'card'
  id: string
  /** Concise summary used for the slide's group aria-label. */
  label: string
  /** Stat-card component rendered as the slide body. */
  component: ComponentType
}

export type ShowcaseSlide = MediaSlide | CardSlide

export const showcaseSlides: ShowcaseSlide[] = [
  // {
  //   kind: 'media',
  //   id: 'platform',
  //   heading: 'Effortlessly manage your claims',
  //   description:
  //     'Sign in to your WyseHub dashboard to oversee partners, referrals, and daily activity from one place.',
  //   image: platformImgOne,
  // },
  // {
  //   kind: 'media',
  //   id: 'matching',
  //   heading: 'Intelligent partner matching',
  //   description:
  //     'WyseHub pairs each claim with the best-suited outsourced partner for optimal outcomes and customer satisfaction.',
  //   image: platformImgTwo,
  // },
  // {
  //   kind: 'media',
  //   id: 'reporting',
  //   heading: 'On-demand reporting',
  //   description:
  //     'Track KPIs, AI-based claim scores, and WyseHub comparisons. Generate, edit, and export reports without leaving the platform.',
  //   image: platformImgThree,
  // },
  {
    kind: 'card',
    id: 'requests',
    label: '6,000 unique AI requests completed for our partners',
    component: RequestsStatCard,
  },
  {
    kind: 'card',
    id: 'clients',
    label: 'New clients signed across insurance',
    component: ClientsStatCard,
  },
  {
    kind: 'card',
    id: 'pricing',
    label: 'Pay-per-use pricing with no setup costs',
    component: PricingStatCard,
  },
  {
    kind: 'card',
    id: 'compliance',
    label: 'FCA and GDPR compliant — traceable by design',
    component: ComplianceStatCard,
  },
]
